import React from 'react'
import logo from "../assets/bingeboxlogo.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faBars, faXmark} from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'

const NavBar = () => {

function clearSearch() {
    sessionStorage.removeItem('movies');
    sessionStorage.removeItem('searchQuery');
}

// Sandwich Menu
function openMenu() {
    document.body.classList += " menu--open";
  }
  
  function closeMenu() {
    document.body.classList.remove("menu--open");
  }

  return (
    <nav>
    <div className="nav__content">
            <figure className="nav__logo--wrapper">
              <Link to="/" onClick={clearSearch}><img src={logo} alt="bingebox logo" className="nav__logo"/></Link>
             </figure>
             <div className="nav__links">
               <Link to="/" className="nav__link link__hover-effect" onClick={clearSearch}><b> Home</b></Link>
                 <Link to="/browse" className="nav__link link__hover-effect"><b>Browse</b></Link>
                 <Link to="trending" className="nav__link link__hover-effect"><b>Trending</b></Link>
                 <Link to="/bingelist" className="nav__link link__hover-effect"><b>Bingelist</b></Link>
                 <button className="btn__menu" onClick={openMenu}><FontAwesomeIcon icon={faBars}/></button>
                 <div className="menu__backdrop">
                     <button className="btn__menu btn__menu--close" onClick={closeMenu}><FontAwesomeIcon icon={faXmark}/>
                     </button>
                     <div className="menu__lists">
                     <ul>
                         <li className="menu__list"> 
                            <Link to="/"><p className="menu__link" onClick={closeMenu}>Home</p></Link>
                         </li>
                         <li className="menu__list"> 
                             <Link to="/browse"><p className="menu__link" onClick={closeMenu}>Browse</p></Link>
                         </li>
                         <li className="menu__list"> 
                             <Link to="/trending"><p className="menu__link no-click" onClick={closeMenu}>Trending</p></Link>
                         </li>
                         <li className="menu__list menu__list--primary-link"> 
                             <Link to="/bingelist"><p className="menu__list--primary">Bingelist</p></Link>
                         </li>
                     </ul>
                 </div>
                 </div> 
             </div>
     </div>
</nav>
  )
}

export default NavBar